<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="goBack">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Relatório Diário AEE
        </h1>
      </v-col>
    </v-row>

    <v-row dense v-if="matricula">
      <v-col cols="12" md="6">
        <v-card outlined color="blue-grey lighten-5" class="pa-3 rounded-lg">
          <div class="d-flex align-center">
            <v-avatar color="primary" size="48" class="mr-3">
              <v-icon dark>mdi-account-school</v-icon>
            </v-avatar>
            <div>
              <div class="text-subtitle-1 font-weight-bold">
                {{ matricula.aluno ? matricula.aluno.nomecompleto : "Nome não disponível" }}
              </div>
              <div class="text-caption text--secondary">
                Código: {{ matricula.aluno ? matricula.aluno.codigo : "- - -" }}
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card outlined color="blue-grey lighten-5" class="pa-3 rounded-lg">
          <div class="d-flex align-center">
            <v-avatar color="green lighten-2" size="48" class="mr-3">
              <v-icon dark>mdi-account-group</v-icon>
            </v-avatar>
            <div>
              <div class="text-subtitle-1 font-weight-bold">
                {{ matricula.turma ? matricula.turma.descricao : "Turma não disponível" }}
              </div>
              <div class="text-caption text--secondary">
                Total de atendimentos: {{ atendimentos.length }}
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pt-3">
        <div class="d-flex justify-space-between">
          <v-btn color="success" @click="criarAtendimento">Criar Novo Atendimento</v-btn>
          <v-text-field
            v-model="search"
            class="ml-2 search-input"
            append-icon="mdi-magnify"
            label="Pesquisar..."
            solo
            dense
            single-line
            hide-details
          />
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="atendimentos"
          :loading="carregando"
          :custom-filter="dataTableFilter"
          :search="search"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr v-for="(atendimento, i) of items" :key="atendimento.id">
                <td>{{ atendimento.id }}</td>
                <td>{{ atendimento.data_formatada }}</td>
                <td>
                  <e-situacao-atendimento
                    :atendimento="atendimento"
                    :i="i"
                    @alterarSituacao="atualizarSituacaoNaLista"
                  />
                </td>
                <td>
                  <div class="d-flex align-center">
                    <v-icon small color="grey" class="mr-2">mdi-clock-outline</v-icon>
                    {{ atendimento.horario ? atendimento.horario.descricao : "- - -" }}
                  </div>
                </td>
                <td class="text-left text-nowrap">
                  <v-tooltip color="primary" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => visualizarAtendimento(atendimento)"
                      >
                        <v-icon small>fa fa-eye </v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar Atendimento</span>
                  </v-tooltip>

                  <v-tooltip color="primary" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="!podeLancarFrequencia(atendimento)"
                        :to="{
                          name: 'educacaoInclusiva.frequencia',
                          params: { matricula_id: matriculaId, atendimento_id: atendimento.id },
                        }"
                      >
                        <v-icon small>fa fa-thumbs-up </v-icon>
                      </v-btn>
                    </template>
                    <span>Lançar Frequência</span>
                  </v-tooltip>

                  <v-tooltip color="primary" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="!podeEditarAtendimento(atendimento)"
                        @click="() => editarAtendimento(atendimento)"
                      >
                        <v-icon small>fa fa-edit </v-icon>
                      </v-btn>
                    </template>
                    <span>Editar Atendimento</span>
                  </v-tooltip>

                  <v-tooltip color="error" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="!podeEditar"
                        @click="() => deletarAtendimento(atendimento)"
                      >
                        <v-icon small>fa fa-trash </v-icon>
                      </v-btn>
                    </template>
                    <span>Deletar Atendimento</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <e-modal-detalhes-lancamento-aee
      v-if="dialogDetalhes && matricula"
      :dialog.sync="dialogDetalhes"
      :lancamento="atendimentoSelecionado"
      :matricula="matricula"
    />
  </main-template>
</template>

<script>
import { dataTableFilter } from "@/plugins/searchQuery";
import AtendimentoAEE from "@/Models/AtendimentoAEE";
import ESituacaoAtendimento from "@/components/EducacaoInclusiva/ESituacaoAtendimento.vue";

export default {
  components: { ESituacaoAtendimento },
  data() {
    return {
      carregando: false,
      dataTableFilter,
      search: "",
      matricula: null,
      atendimentos: [],
      // equivalente ao can_edit_aula do Diário Online, resolvido pela API por matrícula
      podeEditar: false,
      dialogDetalhes: false,
      atendimentoSelecionado: null,
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Data", value: "data_formatada" },
          { text: "Situação", value: "descricaoSituacao" },
          { text: "Horário", value: "horario.descricao" },
          { text: "Ações", value: "actions", sortable: false, width: "200px" },
        ],
      },
    };
  },
  computed: {
    matriculaId() {
      return parseInt(this.$route.params.matricula_id, 10);
    },
  },
  async mounted() {
    await this.carregarAtendimentos();
  },
  methods: {
    async carregarAtendimentos() {
      this.carregando = true;
      this.$loaderService.open("Carregando atendimentos...");
      try {
        const response = await this.$services.educacaoInclusivaService.listar(this.matriculaId);
        this.matricula = response.matricula;
        this.podeEditar = Boolean(response.podeEditar);
        this.atendimentos = response.lancamentos.map(
          (lancamento) => new AtendimentoAEE(lancamento)
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.carregando = false;
      this.$loaderService.close();
    },
    atualizarSituacaoNaLista({ atendimentoAtualizado, i }) {
      this.$set(this.atendimentos, i, new AtendimentoAEE(atendimentoAtualizado));
    },
    /**
     * Mesmas travas do Diário Online: depois de definida a situação, só quem tem
     * aulas.atualizarAposDefinirSituacao lança frequência, e editar fica restrito a
     * "Aguardando confirmação" e "Aula em conflito".
     */
    podeLancarFrequencia(atendimento) {
      if (!this.podeEditar) return false;
      if (atendimento.descricaoSituacao === "Aguardando confirmação") return true;
      return this.$can(["aulas.atualizarAposDefinirSituacao"]);
    },
    podeEditarAtendimento(atendimento) {
      if (!this.podeEditar) return false;
      return ["Aguardando confirmação", "Aula em conflito"].includes(atendimento.descricaoSituacao);
    },
    criarAtendimento() {
      this.$router.push({
        name: "educacaoInclusiva.create",
        params: { matricula_id: this.matriculaId },
      });
    },
    editarAtendimento(atendimento) {
      this.$router.push({
        name: "educacaoInclusiva.edit",
        params: { matricula_id: this.matriculaId, lancamento_id: atendimento.id },
      });
    },
    visualizarAtendimento(atendimento) {
      this.atendimentoSelecionado = {
        ...atendimento,
        bimestre_desc: atendimento.bimestreDescricao,
      };
      this.dialogDetalhes = true;
    },
    async deletarAtendimento(atendimento) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza de que deseja apagar este atendimento?",
        confirmationCode: atendimento.id,
        confirmationMessage: `Por favor, digite <strong>${atendimento.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => this.$modals.close(),
            props: { color: "warning", small: true },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Excluindo atendimento...");
              try {
                await this.$services.educacaoInclusivaService.remover(atendimento.id);
                const index = this.atendimentos.findIndex((a) => a.id === atendimento.id);
                if (index > -1) this.atendimentos.splice(index, 1);
                this.$toast.success("Atendimento excluído com sucesso!");
              } catch (error) {
                this.$handleError(error);
              } finally {
                this.$loaderService.close();
              }
            },
            props: { color: "error", small: true },
          },
        ],
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.v-data-table >>> tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}
</style>
